module.exports = "/_next/static/media/Video3.354c3bf4972ebd7b055e573f0a0cb18e.mp4";